<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Cadastro dos Planos de Conta.</span>
                <br />
                <span class="navigation">Cadastros > Planos de Conta</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div>
              <template v-if="validation.hasError('pgcc.conta')">
                <InlineMessage>{{ validation.firstError('pgcc.conta') }}</InlineMessage>
              </template>
              <template v-if="validation.hasError('pgcc.nome')">
                <InlineMessage>{{ validation.firstError('pgcc.nome') }}</InlineMessage>
              </template>
            </div>
            <div class="row">
              <div class="col-md-3 mb-2">
                <label for="conta">Conta:</label>
                <span class="p-fluid">
                  <InputText type="text" id="conta" maxlength="40" v-model="pgcc.conta"
                    :class="{ 'p-error': validation.hasError('pgcc.conta') }" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" maxlength="250" v-model="pgcc.nome"
                    :class="{ 'p-error': validation.hasError('pgcc.nome') }" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-10 mb-2">
                <label for="desc">Descrição: </label>
                <span class="p-fluid">
                  <textarea id="desc" name="desc" v-model="pgcc.descricao" rows="5" maxlength="500"/>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="tipo">Tipo:</label>
                <span class="p-fluid">
                  <Dropdown id="tipo" name="tipo" v-model="selectedTipo" :options="tipos" optionLabel="nome"
                    placeholder="Tipo:" />
                </span>
              </div>
            </div>
            <div class="row">

              <div class="col-md-6 mb-2">
                <label for="contaSuperior">Conta Superior:</label>
                <span class="p-fluid">
                  <AutoComplete id="contaSuperior" v-model="selectedContaSuperior" :dropdown="true"
                    :suggestions="filteredContaSuperior" @complete="searchContaSuperior($event)" field="nome"
                    placeholder="Pesquisar">
                    <template #item="slotProps">
                      <div class="p-fluid" style="max-width: 50vw">
                        {{ slotProps.item.conta + ' - ' + slotProps.item.nome }}
                      </div>
                    </template>
                  </AutoComplete>
                </span>
              </div>
            </div>

            <hr />
            <template>
              <Button label="Gravar" title="Gravar" type="submit" class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check" :disabled="loading">
              </Button>
              <router-link to="/pgcc">
                <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
                  icon="pi pi-arrow-left" :disabled="loading"></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import PgccService from "../services/nfse/pgcc.service";
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
  name: "pgccCadastro",
  data() {
    return {
      currentUser: null,
      loading: false,
      pgcc: {},
      tipos: [],
      selectedTipo: null,
      filteredContaSuperior: null,
      selectedContaSuperior: null,
    };
  },
  async created() {
    this.currentUser = LoginService.currentUserValue;
    this.pgcc.conta = '';
    this.pgcc.nome = '';
    this.pgccId = this.$route.params.id;

    await this.carregarTipos();
    this.selectedTipo = this.tipos[0];


    if (this.pgccId != null) {
      await this.obterPgcc();
    }
  },
  validators: {
    "pgcc.conta": function (value) {
      return Validator.value(value)
        .required("Conta Obrigatório")
        .maxLength(40, "Deve ser menor ou igual a 40");
    },
    "pgcc.nome": function (value) {
      return Validator.value(value)
        .required("Nome Obrigatório")
        .maxLength(250, "Deve ser menor ou igual a 250");
    }
  },
  methods: {
    async searchContaSuperior(event) {
      this.filteredContaSuperior = await PgccService.findAllPaiByFiltro(
        this.currentUser.contribuinte.idContribuinte,
        event.query
      );
    },
    async obterPgcc() {
      PgccService.get(this.pgccId).then(
        response => {
          this.pgcc = response.data;
          this.selectedTipo = this.pgcc.tipo;
          this.selectedContaSuperior = this.pgcc.pgccPai;
        },
        error => {
          let errorMessage = "Houve um problema ao buscar o Plano de Conta!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        });
    },
    async carregarTipos() {
      return PgccService.findAllTipos()
        .then((responseNota) => {
          this.tipos = responseNota.data;
        })
    },
    onSubmit() {
      this.loading = true;
      this.$validate().then(success => {
        if (success) {
          this.salvar();
        }
      });
      this.loading = false;
    },
    salvar() {
      this.pgcc.idContribuinte = this.currentUser.contribuinte.idContribuinte;
      this.pgcc.idBolTipoConta = this.selectedTipo.id;
      this.pgcc.idContaPai = (this.selectedContaSuperior && this.selectedContaSuperior.id ? this.selectedContaSuperior.id : null);
      PgccService.save(this.pgcc).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Plano de Conta salvo com sucesso"
          });
          this.$router.push("pgcc");
        },
        error => {
          let errorMessage = "Houve um problema ao salvar o Plano de Conta!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    }
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 12px;
}
</style>